import React from "react"
import { Router } from "@reach/router"
import axios from "axios"

import Seo from "../components/seo"
import Layout from "../components/layout"
import JobDetail from "../components/jobs/JobDescription"
import Apply from "../components/jobs/Apply"

import "bootstrap/dist/css/bootstrap.min.css"

axios.defaults.headers.put["Content-Type"] = "application/x-www-form-urlencoded"

const App = () => {
  return (
    <Layout downloadFooter="false">
      <Seo/>
      <Router>
        <JobDetail exact path="/sparkle-jobs/description/:id" />
        <Apply exact path="/sparkle-jobs/:id/apply" />
      </Router>
    </Layout>
  )
}

export default App
